import React, { useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { selectFilters } from '../state';

export default function AuditTrailFilters({onChange}: {onChange: Function}) {
  const filters = useSelector(selectFilters);
  
  const [roaPassed, setRoaPassed] = useState<boolean | ''>(filters.roaPassed);
  const [genotypingPass, setGenotypingPass] = useState<boolean | ''>(filters.genotypingPass);

  const handleRoaPassedChange = (value: boolean | '') => {
    setRoaPassed(value)
    onChange({
      roaPassed: value,
      genotypingPass: genotypingPass.toString()
    });
  }

  const handleGenotypingPassChange = (value: boolean | '') => {
    setGenotypingPass(value);
    onChange({
      roaPassed: roaPassed.toString(),
      genotypingPass: value
    });
  }
  
  return (
    <Grid container
      direction="row"
      justify="flex-end"
      alignItems="center" style={{padding: '0px 10px'}}>
      <FormControl style={{width: 270, marginLeft: 20}}>
        <InputLabel id="county-result-posted-label">Clinical Results Processed (HL7)</InputLabel>
        <Select
          labelId="county-result-posted-label"
          id="county-result-posted"
          value={roaPassed}
          onChange={(event) => handleRoaPassedChange(event.target.value as boolean | '')}
        >
          <MenuItem value={""}><br /></MenuItem>
          <MenuItem value={"true"}>roaPassed: true</MenuItem>
          <MenuItem value={"false"}>roaPassed: false</MenuItem>
        </Select>
      </FormControl>
      <FormControl style={{width: 230, marginLeft: 20}}>
        <InputLabel id="dna-genotyping-result-posted-label">Genotyping Results Posted</InputLabel>
        <Select
          labelId="dna-genotyping-result-posted-label"
          id="dna-genotyping-result-posted"
          value={genotypingPass}
          onChange={(event) => handleGenotypingPassChange(event.target.value as boolean | '')}
        >
          <MenuItem value={""}><br /></MenuItem>
          <MenuItem value={"true"}>genotypingPass: true</MenuItem>
          <MenuItem value={"false"}>genotypingPass: false</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
}